// Production
export const baseURLBackend = 'https://in6backend.herokuapp.com/';
export const baseURLFrontend = 'https://www.in6.com.br';
export const candidatesUrlFrontend = 'https://candidatos.in6.com.br';

// Local Tests
// export const baseURLBackend = 'http://localhost:8080/';
// export const baseURLFrontend = 'http://localhost:3000';
// export const candidatesUrlFrontend = 'http://candidatos.localhost:3000';
